/**
 * Created by Administrador on 16/05/2018.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('clients', {
                url: '/clients?page&size',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ADMIN
                },
                views:{
                    'main':{
                        templateUrl: 'app/admin/configGeneral/client/clients.html',
                        controller: 'clientsCtrl',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['client']);
                    }],
                    clients: ['clientService','$stateParams', function(clientService,$stateParams){
                        return clientService.getAllApplicationPage($stateParams.page, $stateParams.size);
                    }]
                }
            })
            .state('clientNew', {
                url: '/client/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ADMIN
                },
                views:{
                    'main':{
                        templateUrl: 'app/admin/configGeneral/client/newClient.html',
                        controller: 'newClientCtrl',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['client']);
                    }]
                }
            })
            .state('clientEdit', {
                url: '/client/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main':{
                        templateUrl: 'app/admin/configGeneral/client/editClient.html',
                        controller: 'editClientCtrl',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['client']);
                    }],
                    client: ['clientService', '$stateParams', function(clientService, $stateParams){
                        return clientService.getAllOauthClient($stateParams.id)
                    }]
                }
            })
            /*.state('userDelete', {
                parent: 'users',
                url: '/user/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/configGeneral/user/deleteUser.html',
                        controller: 'deleteUserController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            'userId': [function() {
                                return $stateParams.id
                            }],
                            'user': ['userService', function(userService) {
                                return userService.getUser($stateParams.id)
                            }]
                        }
                    }).result.then(function() {
                        $state.go('users', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });*/
    }
})();
